<template>
  <div class="koc-block koc-payment-billing-details-block">
    <div class="koc-full">
      <div class="koc-tabs koc-header-tabs">
        <span
          :class="{ active: 'list' === state.active }"
          :disabled="!profiles || !profiles.length"
          class="koc-button koc-ripple koc-capitalize"
          @click="toggle('list'), emitToggle('list')"
        >Existing
          Payment Methods</span>
        <span
          :class="{ active: 'create' === state.active }"
          class="koc-button koc-ripple koc-capitalize"
          @click="toggle('create'), emitToggle('create')"
        >Add
          New</span>
      </div>
      <div class="koc-inner">
        <div
          :class="{ hidden: 'create' === state.active }"
          class="koc-block koc-list"
        >
          <payment-list-component
            :default-profile="defaultProfile"
            :profiles="profiles"
            :selected-profile="selectedProfile"
            :show-activation-options="showActivationOptions"
            @activate="activate"
            @remove="remove"
            @update="update"
          />
        </div>
        <div
          :class="{ hidden: 'list' === state.active }"
          class="koc-block koc-create"
        >
          <payment-create-component
            :can-create="canCreate"
            :profiles="profiles"
            @cancel="state.active='list'"
            @create="create"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./billing-details.js"></script>
<style lang="scss" scoped src="./billing-details.scss"></style>
